export const enum KeyCode {
  BACKSPACE = 8,
  TAB = 9,
  ENTER = 13,
  END = 35,
  HOME = 36,
  ARROW_LEFT = 37,
  ARROW_RIGHT = 39,
  ARROW_DOWN = 40,
  DELETE = 46,
  BRACKET_LEFT = 220,
  BRACKET_RIGHT = 221,
}



// WEBPACK FOOTER //
// ./src/common/enums/KeyCode.ts